export enum FTUXType {
    CARD_MATCH = 'FTUX_card_match',
    CARD_DECK = 'FTUX_card_deck',
    BONUS_STREAK = 'FTUX_bonus_streak',
    HARVEST = 'FTUX_harvest',
    UNDO = 'FTUX_unlock_undo',
    BOMB_CARD = 'FTUX_bomb_card',
    JOKER = 'FTUX_unlock_joker',
    LOCK_CARD = 'FTUX_lock_card',
    RISE_LOWER_CARDS = 'FTUX_rise_lower_cards',
    STONE_CARD = 'FTUX_stone_card',
    TOOLBOX_UNLOCK = 'FTUX_toolbox',
    SHUFFLE_BOOSTER = 'FTUX_unlock_shuffle',
    BULLSEYE_BOOSTER = 'FTUX_unlock_bullseye',
    SPIN_WHEEL = 'FTUX_unlock_spin_wheel',
    GOLD_CARD = 'FTUX_gold_card',
    STAR_CHEST = 'FTUX_star_chest',
    QUESTS = 'FTUX_quests',
    DAILY_LOGIN = 'FTUX_daily_login',
    ICE_CARD = 'FTUX_ice_card',
    PET_UNLOCK = 'FTUX_pet_unlock',
    SCYTHE = 'FTUX_scythe_card',
    TOMATO_BOMB = 'FTUX_tomato_bomb',
    PLUS_THREE_CARD = 'FTUX_plus_three_card',
    ROPE_CARD = 'FTUX_rope_card',
    TORNADO_CARD = 'FTUX_tornado_card',
    FOG_CARD = 'FTUX_fog_card',
    CONNECTED_CARDS = 'FTUX_connected_cards',
    LUCKY_WHEEL = 'FTUX_lucky_wheel',
    FARM_BTN = 'FTUX_farm_btn',
    FARM = 'FTUX_farm',
    FARM_PET = 'FTUX_farm_pet',
    XMAS = 'FTUX_xmas',
    TNT_MODIFIER = 'FTUX_tnt_modifier',
    PLINKO_CARD = 'FTUX_plinko_card',
}
